import React from 'react'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Hero from '../components/hero'
import ArticlePreview from '../components/article-preview'
// import BlogPreview from '../components/blog-preview'
import NewsPreview from '../components/news-preview'
// import styles from './index.module.css'
import moment from 'moment'


class RootIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const news = get(this, 'props.data.allContentfulBlogPost.edges')
    const now = Date.now()
    const articles = get(this, 'props.data.allContentfulArticle.edges')
    let filteredArticles = [];
    if (articles) {
      filteredArticles = articles.filter( function(edgeItem) {
        const publishDateEpoch = moment(edgeItem.node.publishDate).format("x");
        return publishDateEpoch < now
      });
    }

    function displayDate(thisDate) {
      return moment(thisDate).format("DD MMM YYYY");
    }

    return (
      <div style={{ background: '#fff' }}>
        <Helmet title={siteTitle} />
        {/* <Hero /> */}
        <section className="section-featured-articles">
          <div className="section-inner">
            <h2 className="section-headline section-title">Artikel Terpilih</h2>
            <ul className="article-list grid-x grid-padding-x grid-padding-y small-up-1 medium-up-2 large-up-3">
              {filteredArticles.map(({ node }) => {
                return (
                  <li key={node.slug} className="article-list-item item cell card-item card-with-image">
                    <ArticlePreview article={node} />
                  </li>
                )
              })}
            </ul>
          </div>
        </section>
        <section className="section-youcat-foryou">
          <div className="title-band">
            <h2 className="">Bagaimana <span className="youcatWhite"><img src={'https://static.youcat.id/logo/youcat-white.svg'} alt="YOUCAT" title="YOUCAT" /></span> Bisa Merubah Hidupmu?</h2>
          </div>
          <ul className="band-list">
            <li className="list-item text-center item-1">
              <a href="/page/youcat-for-omk">
                <div className="item ">
                  <h3 className="itemTitle">OMK</h3>
                </div>
              </a>
            </li>
          </ul>
        </section>
        <section className="section-participate">
          <div className="section-inner">
            <h2 className="section-title">Berpartisipasi</h2>
            <div className="grid-x grid-padding-x grid-padding-y text-center">
              <div className="cell medium-auto item">
                <div className="itemContent">
                  <div className="image">
                    <img src={'/img/stickmen/social-doctrine-love.png'} alt="YOUCAT" title="YOUCAT" />
                  </div>
                  <div className="desc">Sumbangkan waktu dan tenagamu untuk sobat-sobatmu!</div>
                  <div className="item-action text-center"><a href="/page/volunteer" className="button button-yellow">Volunteer</a></div>
                </div>
              </div>
              <div className="cell medium-auto item">
                <div className="itemContent">
                  <div className="image">
                    <img src={'/img/stickmen/present-gift.png'} alt="YOUCAT" title="YOUCAT" />
                  </div>
                  <div className="desc">Sumbangkan sedikit uang sakumu untuk karya ini!</div>
                  <div className="item-action text-center"><a href="/page/donate" className="button button-yellow">Donasi</a></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        { news ? (
        <section className="section-featured-blogs"><div className="section-inner">
          <h2 className="section-headline section-title">Berita Terbaru</h2>
          <ul className="blog-list news-list grid-x grid-padding-x grid-padding-y small-up-1 medium-up-2 large-up-3">
            {news.map(({ node }) => {
              return (
                <li key={node.slug} className="blog-list-item item cell card-item card-with-image">
                  <NewsPreview news={node} />
                </li>
              )
            })}
          </ul>
        </div></section>
        ): ''}
      </div>
    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query HomeQuery {
    allContentfulBlogPost(
      sort: { fields: [publishDate], order: DESC }
      limit: 6
    ) {
      edges {
        node {
          title
          slug
          publishDate
          heroImage {
            sizes(maxWidth: 350, maxHeight: 196, resizingBehavior: THUMB) {
             ...GatsbyContentfulSizes_withWebp
            }
          }
          excerpt
        }
      }
    }
    allContentfulArticle(
      filter: {
        featured: { eq: true }
      }
      limit: 16
      sort: {
        fields: [publishDate],
        order: DESC
      }
    ) {
      edges {
      node {
          title
          slug
          publishDate
          heroImage {
            sizes(maxWidth: 640, maxHeight: 480, resizingBehavior: FILL) {
             ...GatsbyContentfulSizes_withWebp
            }
          }
          excerpt
          featured
          tags
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/index.js